import React from 'react';

const links = [
    {
        name: 'TikTok',
        href: 'https://www.tiktok.com/@dry.ice.bulls',
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="h-5 w-5">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.51a8.16 8.16 0 0 0 4.77 1.52V6.58a4.85 4.85 0 0 1-1.84-.35Z" />
            </svg>
        ),
    },
    {
        name: 'YouTube',
        href: 'https://www.youtube.com/@DryIceBulls',
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="h-5 w-5">
                <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.6 3.6 12 3.6 12 3.6s-7.6 0-9.4.5A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.8.5 9.4.5 9.4.5s7.6 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.4 31.4 0 0 0 24 12a31.4 31.4 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.3 3.6-6.3 3.6Z" />
            </svg>
        ),
    },
    {
        name: 'Facebook',
        href: 'https://www.facebook.com/profile.php?id=61584626505373',
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="h-5 w-5">
                <path d="M24 12a12 12 0 1 0-13.87 11.85v-8.38H7.08V12h3.05V9.35c0-3 1.79-4.67 4.53-4.67 1.31 0 2.69.23 2.69.23v2.95h-1.51c-1.49 0-1.96.93-1.96 1.87V12h3.33l-.53 3.47h-2.8v8.38A12 12 0 0 0 24 12Z" />
            </svg>
        ),
    },
];

const SocialLinks = ({ className = '' }) => (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-links">
        {links.map((l) => (
            <a
                key={l.name}
                href={l.href}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={l.name}
                title={l.name}
                className="h-10 w-10 inline-flex items-center justify-center border border-white/15 text-white/70 hover:text-brand-ink hover:bg-brand-primary hover:border-brand-primary transition-colors"
                data-testid={`social-${l.name.toLowerCase()}`}
            >
                {l.icon}
            </a>
        ))}
    </div>
);

export default SocialLinks;
